import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { IconButton, Stack, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { PlayersAroundTheWorld } from '../components/leaderboards/PlayersAroundTheWorld';

type PropTypes = {
  close: () => void;
  open: boolean;
  userLocations: any[];
};

export const PlayersAroundTheWorldDialog = ({
  close,
  open,
  userLocations,
}: PropTypes) => {
  return (
    <Dialog fullScreen open={open} onClose={close}>
      <IconButton onClick={close} sx={{ position: 'absolute' }}>
        <CloseIcon />
      </IconButton>
      <DialogTitle textAlign={'center'}>
        <Stack spacing={2}>
          <Typography variant="h5">Where is everyone from?</Typography>
          <Typography>
            zoom and hover the dots to view player profiles
          </Typography>
        </Stack>
      </DialogTitle>
      <DialogContent>
        <PlayersAroundTheWorld
          userLocations={userLocations}
        ></PlayersAroundTheWorld>
      </DialogContent>
    </Dialog>
  );
};
